<template>
  <crud-modal
    :show="show"
    :title="modalTitle"
    size="lg"
    :show-save="false"
    cancel-text="Cerrar"
    nested
    @close="$emit('close')"
  >
    <template #title>
      <div class="d-flex align-items-center">
        <span>{{ modalTitle }}</span>
        <span
          v-if="bs && (bs.activo !== undefined && bs.activo !== null)"
          :class="[
            'badge ml-2',
            (bs.activo == 1 || bs.activo === '1') ? 'badge-success' : 'badge-danger'
          ]"
          style="font-size: 0.8rem; font-weight: normal; padding: 4px 10px; border-radius: 4px;"
        >
          <i
            :class="(bs.activo == 1 || bs.activo === '1') ? 'bi bi-check-circle mr-1' : 'bi bi-x-circle mr-1'"
          ></i>
          {{ (bs.activo == 1 || bs.activo === '1') ? 'Activo' : 'Inactivo' }}
        </span>
      </div>
    </template>

    <div v-if="bs" class="billing-sequence-details">
      <!-- Fila 1: Integrador a todo el ancho -->
      <div class="form-row">
        <div class="form-group col-12 mb-2">
          <label class="font-weight-bold small text-muted mb-0">Integrador</label>
          <input
            class="form-control form-control-sm bg-light"
            readonly
            type="text"
            :value="bs.integrador || getIntegradorName(bs.id_integrador) || '-'"
          />
        </div>
      </div>

      <!-- Fila 2: Secuencia y Descripción -->
      <div class="form-row">
        <div class="form-group col-md-6 mb-2">
          <label class="font-weight-bold small text-muted mb-0">Secuencia</label>
          <input
            class="form-control form-control-sm bg-light font-weight-bold text-primary"
            readonly
            type="text"
            :value="bs.sequence || '-'"
          />
        </div>
        <div class="form-group col-md-6 mb-2">
          <label class="font-weight-bold small text-muted mb-0">Descripción</label>
          <input
            class="form-control form-control-sm bg-light"
            readonly
            type="text"
            :value="bs.descripcion || '-'"
          />
        </div>
      </div>

      <!-- Fila 3: Precios -->
      <div class="form-row">
        <div class="form-group col-md-4 mb-2">
          <label class="font-weight-bold small text-muted mb-0">Precio s/ Impuestos</label>
          <input
            class="form-control form-control-sm bg-light"
            readonly
            type="text"
            :value="formatMoney(bs.full_price !== undefined && bs.full_price !== null ? bs.full_price : (bs.precio_sin_imp !== undefined && bs.precio_sin_imp !== null ? bs.precio_sin_imp : (bs.scPrice !== undefined && bs.scPrice !== null ? bs.scPrice : bs.fullPrice)))"
          />
        </div>
        <div class="form-group col-md-4 mb-2">
          <label class="font-weight-bold small text-muted mb-0">Precio c/ Impuestos</label>
          <input
            class="form-control form-control-sm bg-light"
            readonly
            type="text"
            :value="formatMoney(bs.full_price_tax !== undefined && bs.full_price_tax !== null ? bs.full_price_tax : (bs.precio_con_imp !== undefined && bs.precio_con_imp !== null ? bs.precio_con_imp : (bs.scPriceImp !== undefined && bs.scPriceImp !== null ? bs.scPriceImp : bs.fullPriceTax)))"
          />
        </div>
        <div class="form-group col-md-4 mb-2">
          <label class="font-weight-bold small text-muted mb-0">Precio Mínimo</label>
          <input
            class="form-control form-control-sm bg-light"
            readonly
            type="text"
            :value="formatMoney(bs.min_price_bs !== undefined && bs.min_price_bs !== null ? bs.min_price_bs : (bs.precio_min !== undefined && bs.precio_min !== null ? bs.precio_min : bs.minPriceBS))"
          />
        </div>
      </div>

      <!-- Fila 4: Parámetros de cobro -->
      <div class="form-row">
        <div class="form-group col-md-4 mb-2">
          <label class="font-weight-bold small text-muted mb-0">Frecuencia</label>
          <input
            class="form-control form-control-sm bg-light"
            readonly
            type="text"
            :value="bs.frecuency || bs.scFrequency || '-'"
          />
        </div>
        <div class="form-group col-md-4 mb-2">
          <label class="font-weight-bold small text-muted mb-0">Lifetime</label>
          <input
            class="form-control form-control-sm bg-light"
            readonly
            type="text"
            :value="bs.lifetime || bs.scLifetime || '-'"
          />
        </div>
        <div class="form-group col-md-4 mb-2">
          <label class="font-weight-bold small text-muted mb-0">Restricciones</label>
          <input
            class="form-control form-control-sm bg-light"
            readonly
            type="text"
            :value="bs.bill_restriction || bs.billRestriction || '-'"
          />
        </div>
      </div>

      <!-- Tabla de Billing Codes correspondientes a la secuencia -->
      <div class="mt-3 pt-3 border-top">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="font-weight-bold small text-muted mb-0">
            <i class="bi bi-receipt mr-1 text-primary"></i>Billing Codes correspondientes a la secuencia
          </label>
          <span v-if="!loadingCodes" class="badge badge-info">
            {{ billingCodes.length }} código(s)
          </span>
        </div>

        <div v-if="loadingCodes" class="text-center py-3 alert alert-light border">
          <div class="spinner-border spinner-border-sm text-primary mr-2" role="status"></div>
          <span class="text-muted small">Cargando billing codes de la secuencia...</span>
        </div>

        <div v-else-if="billingCodes.length > 0" class="table-responsive border rounded">
          <table class="table table-sm table-striped table-hover mb-0">
            <thead class="thead-light">
              <tr>
                <th scope="col" style="width: 60px;" class="text-center">ID</th>
                <th scope="col">Código TAS</th>
                <th scope="col">Descripción</th>
                <th scope="col" class="text-right">Precio s/ Imp.</th>
                <th scope="col" class="text-right">Precio c/ Imp.</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="code in billingCodes" :key="code.id_billing_code || code.id">
                <td class="text-center font-weight-bold align-middle">{{ code.id_billing_code || code.id }}</td>
                <td class="align-middle"><code>{{ code.cod_tas || '-' }}</code></td>
                <td class="align-middle">{{ code.descripcion || '-' }}</td>
                <td class="text-right align-middle text-muted small">{{ formatMoney(code.precio_sin_imp !== undefined && code.precio_sin_imp !== null ? code.precio_sin_imp : code.precioSinImp) }}</td>
                <td class="text-right align-middle">{{ formatMoney(code.precio_con_imp !== undefined && code.precio_con_imp !== null ? code.precio_con_imp : code.precioConImp) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="alert alert-light border text-center text-muted py-2 mb-0 small">
          <i class="bi bi-info-circle mr-1"></i>Esta secuencia no tiene billing codes asociados.
        </div>
      </div>
    </div>
  </crud-modal>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CrudModal from "../utiles/CrudModal.vue";

export default {
  name: "AtributosBillingSequenceModal",
  components: {
    CrudModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    billingSequence: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      billingCodes: [],
      loadingCodes: false,
      detailData: null,
    };
  },
  computed: {
    ...mapGetters("integrador", ["integradores"]),
    ...mapGetters("auth", ["user"]),

    bs() {
      return Object.assign({}, this.billingSequence || {}, this.detailData || {});
    },
    modalTitle() {
      const id = this.bs.id_billing_sequence || this.bs.id || '';
      return id ? `Billing Sequence ${id}` : 'Billing Sequence';
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.fetchBillingCodes();
      } else {
        this.billingCodes = [];
        this.detailData = null;
      }
    },
    billingSequence() {
      if (this.show) {
        this.fetchBillingCodes();
      }
    },
  },
  methods: {
    getIntegradorName(id) {
      if (!id) return "";
      const list =
        (this.integradores && this.integradores.data && this.integradores.data.length && this.integradores.data) ||
        (this.user && this.user.integradores && Array.isArray(this.user.integradores) && this.user.integradores) ||
        [];
      const found = list.find((i) => (i.id_integrador || i.id) == id);
      return found ? found.integrador : String(id);
    },

    fetchBillingCodes() {
      const id = this.bs.id_billing_sequence || this.bs.id;
      if (!id) {
        this.billingCodes = [];
        this.detailData = null;
        return;
      }
      this.loadingCodes = true;
      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/getCuadro", {
          billing_codes: id,
        })
        .then((response) => {
          if (response && response.data) {
            this.billingCodes = Array.isArray(response.data.payments)
              ? response.data.payments
              : [];
            this.detailData = response.data;
          } else {
            this.billingCodes = [];
            this.detailData = null;
          }
        })
        .catch(() => {
          this.billingCodes = [];
          this.detailData = null;
        })
        .finally(() => {
          this.loadingCodes = false;
        });
    },

    formatMoney(val) {
      if (val === null || val === undefined || val === "" || val === "-") return "-";
      const cleaned = String(val).replace(/^\$\s*/, "").trim();
      const num = Number(cleaned);
      if (isNaN(num)) return cleaned;
      return num.toFixed(2);
    },
  },
};
</script>
